import { render, staticRenderFns } from "./D008GT.vue?vue&type=template&id=c7997106&scoped=true&"
import script from "./D008GT.vue?vue&type=script&lang=js&"
export * from "./D008GT.vue?vue&type=script&lang=js&"
import style0 from "./D008GT.vue?vue&type=style&index=0&id=c7997106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7997106",
  null
  
)

export default component.exports